import { organisationConstants } from '../../_constants/organisation.constants';

const initialState = { removeAdminLoading : true, removeAdminMessage: '', removeAdminError: false};

export function removeOrganisationAdmins(state = initialState, action) {
    switch (action.type) {
      case organisationConstants.REQUEST_REMOVE_ADMIN_ORG:
        return {
            removeAdminLoading: true,
            removeAdminMessage: '',
            removeAdminError: false
        };
      case organisationConstants.RESPONSE_REMOVE_ADMIN_ORG:
        return {
            removeAdminLoading: false,
            removeAdminMessage: action.adminListMake,
            removeAdminError: false
        };
      case organisationConstants.ERROR_REMOVE_ADMIN_ORG:
        return { 
            removeAdminLoading: false,
            removeAdminMessage: '',
            removeAdminError: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/removeOrgAdmin.reducer.js